import React from "react";

export function useAsyncEffect(asyncFunc: () => void, deps?: React.DependencyList) {
  return React.useEffect(() => {
    async function f() {
      try {
        await asyncFunc();
      } catch (e) {
        console.error(e);
      }
    }
    f();
  }, deps);
}